import { DateRangeOption } from './types';

const now = new Date();
const currentYear = now.getFullYear();
const thisQuarterStartMonth = Math.floor(now.getMonth() / 3) * 3;
const lastQuarterStartMonth = Math.floor((now.getMonth() - 3) / 3) * 3;

const thisCycleStartYear = currentYear % 2 === 0 ? currentYear - 1 : currentYear;
const thisCycleStart = new Date(thisCycleStartYear, 0, 1);
const thisCycleEnd = new Date(thisCycleStartYear + 2, 0, 0); // Dec 31 of next year
const lastCycleStart = new Date(thisCycleStartYear - 2, 0, 1);
const lastCycleEnd = new Date(thisCycleStartYear, 0, 0); // Dec 31 of last year
export const dateRangeOptions: DateRangeOption[] = [
  {
    value: 'this_month',
    label: 'This Month',
    startDate: new Date(currentYear, now.getMonth(), 1),
    endDate: new Date(currentYear, now.getMonth() + 1, 0),
  },
  {
    value: 'last_month',
    label: 'Last Month',
    startDate: new Date(currentYear, now.getMonth() - 1, 1),
    endDate: new Date(currentYear, now.getMonth(), 0),
  },
  {
    value: 'this_quarter',
    label: 'This Quarter',
    startDate: new Date(currentYear, thisQuarterStartMonth, 1),
    endDate: new Date(currentYear, thisQuarterStartMonth + 3, 0),
  },
  {
    value: 'this_cycle',
    label: 'This Cycle',
    startDate: thisCycleStart,
    endDate: thisCycleEnd,
  },
  {
    value: 'last_quarter',
    label: 'Last Quarter',
    startDate: new Date(currentYear, lastQuarterStartMonth, 1),
    endDate: new Date(currentYear, lastQuarterStartMonth + 3, 0),
  },
  {
    value: 'last_cycle',
    label: 'Last Cycle',
    startDate: lastCycleStart,
    endDate: lastCycleEnd,
  },
];

export const customRangeOption: DateRangeOption = {
  value: 'custom',
  label: 'Custom',
  startDate: new Date(),
  endDate: new Date(),
};
